import BaseView from "./_BaseView";
import PercentageMeter from "../graphs/PercentageMeter";
import HorizontalHistogram from "../graphs/HorizontalHistogram";
import TimeSeriesHistogram from "../graphs/TimeSeriesHistogram";
import StackedBarChart from "../graphs/StackedBarChart";
import Table from "../components/Table";
import LinePercentage from "../graphs/LinePercentage";
import MedianBarChart from "../graphs/MedianBarChart";
import DonutPieChart from "../graphs/DonutPieChart";
import trans from "../util/trans";
import Confirm from "../components/Confirm";
import Api from "../Api";
import Treemap from "../graphs/Treemap.js";
import TabLoad from "../components/TabLoad.js";

export default class AnalyticsGuideView extends BaseView {

    init() {
        super.init();

        if ($('#guidePercentage').length > 0) {
            PercentageMeter({
                url: '/api/analytics/guide_percentage',
                svg: '.guide-percentage',
                container: '#guidePercentage',
                message: function (percentage) {
                    return `<strong>${trans('userprogress', {percentage: percentage})}</strong>`;
                }
            });
        }

        if ($('#stepStop').length > 0) {
            HorizontalHistogram({
                url: '/api/audit',
                svg: '.step-stop',
                container: '#stepStop',

            });
        }

        // if ($('#guideDuration').length > 0) {
            TabLoad('#guideDuration', () => {
                TimeSeriesHistogram({
                    url: '/api/analytics/guide_duration',
                    container: '#guideDuration',
                    svg: '.guide-duration',
                });
            });
        // }

        // if ($('#guideStops').length > 0) {
            TabLoad('#guideStops', () => {
                LinePercentage({
                    container: '#guideStops',
                    svg: '.guide-stops'
                });
            });
        // }

        if ($('#stepDuration').length > 0) {
            TabLoad('#stepDuration', () => {
                MedianBarChart({
                    container: '#stepDuration',
                    svg: '.step-duration'
                });
            });
        }

        if($('.top-guides-treemap').length > 0) {
            const url = $(this).data('url');
            Treemap({
                container: '.top-guides-treemap',
                svg: '.top-guides-svg'
            });
        }

        if ($('#guideAnalyticsTableHalf').length > 0) {
            this.guideTable = new Table('guideAnalyticsTableHalf', '/api/guides/analytics_table', [
                {data: 'title', orderable: true},
                {data: 'started'},
                {data: 'completed', orderable: true},
            ]);
        }

        const tableContainer = $('#usersProgress');
        if (tableContainer.length > 0) {
            const guideid = tableContainer.data('id');
            this.table = new Table('usersProgress', '/api/users/progress?guideid=' + guideid, [
                {data: 'firstname', orderable: true},
                {data: 'lastname'},
                {data: 'email'},
                {data: 'started'},
                {data: 'completed'},
                {data: 'progress', orderable: true},
            ]);
        }

        const wayfinderImpressions = $('#wayfinderImpressions');
        if (wayfinderImpressions.length > 0 ) {
            const guideid = wayfinderImpressions.data('id');
            this.impressions = new Table('wayfinderImpressions',`/api/event/wayfinder/${guideid}`,
                [
                    { data: 'step', orderable: true },
                    { data: 'impressions' },
                ]
            );
        }
       
        const missingReport = $('#stepMissingTable');
        if (missingReport.length > 0) {
            const guideid = missingReport.data('id');
            this.missing = new Table('stepMissingTable', `/api/event/missing?guideid=${guideid}`, [
                {data: 'time', orderable: true},
                {data: 'user'},
                {data: 'step'},
                {data: 'version'},
                {data: 'selector'},
                {data: 'type'},
                {data: 'action'},
                {data: 'tools', orderable: false},
            ]);
        }

        $('body').on('click', '.btn.resolvemiss', function () {
            const id = $(this).parents('div:eq(0)').data('id');
            const $table = $(this).parents('table');
            Confirm({
                ok: Lang.ok,
                title: Lang.resolve,
                msg: Lang.resolvemiss,
                onConfirm: function () {
                    Api.send('/api/event/resolvemiss', { miss_id: id }, 'post').done(function () {
                        $table.trigger('reload');
                    });
                }
            });
        });

        const notificationTracking = $('#notificationTracking');
        if (notificationTracking.length > 0) {
            const guideid = notificationTracking.data('id');
            this.missing = new  Table('notificationTracking',`/api/event/notificationTracking/${guideid}`,
                [
                    { data: 'type', orderable: true },
                    { data: 'count' },
                ]
            );
        }
     
        const openResponseTable = $('#openResponseTable');
        if (openResponseTable.length > 0) {
            const guideid = openResponseTable.data('id');
            this.missing = new Table('openResponseTable', `/api/guides/survey_comments_table?guideid=${guideid}`, [
                {data: 'step'},
                {data: 'prompt'},
                {data: 'comment'},
            ]);
        }

        if ($('[id^=quizAnswerPercentage]').length > 0) {
            $('[id^=quizAnswerPercentage]').each(function(){
                PercentageMeter({
                    url: '/api/analytics/quiz_percentage?step='+ $(this).data('step-ind'),
                    svg: '.quiz-percentage-' + $(this).data('step-ind'),
                    container: '#' + $(this).attr('id'),
                    graphText: 'Quiz Pass Rate',
                    message: function (percentage) {
                        return `<strong>${trans('quizresults', {percentage: percentage})}</strong>`;
                    }
                });
            });
        }
        if ($('[id^=surveyRatingsGraph]').length > 0) {
            $('[id^=surveyRatingsGraph]').each(function(){
                LinePercentage({
                    svg: '.survey-rating-' + $(this).data('step-ind'),
                    container: '#' + $(this).attr('id'),
                });
            });
        }

        if ($('[id^=surveyBarChart]').length > 0) {
            $('[id^=surveyBarChart]').each(function(){
                StackedBarChart({
                    bar1label: 'Selected',
                    svg: '.survey-multi-choice-' + $(this).data('step-ind'),
                    container: '#' + $(this).attr('id'),
                });
            });
        }

        if ($('[id^=surveyDonutChart]').length > 0) {
            $('[id^=surveyDonutChart]').each(function(){
                DonutPieChart({
                    svg: '.survey-multi-choice-donut-' + $(this).data('step-ind'),
                    legend: '.survey-multi-choice-legend-' + $(this).data('step-ind'),
                    container: '#' + $(this).attr('id'),
                });
            });
        }

    }
}
